// extracted by mini-css-extract-plugin
export default {"sponsorNameBillDetails":"TopFiveSponsorsList_sponsorNameBillDetails__22oMh"};